export default __webpack_public_path__ + "static/media/x.c761e4ed.svg";